import React from 'react';
import { Popconfirm, message, Divider } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import RoleAdd from './components/RoleAdd';
import { post, postFrom, config } from '../../axios';
import { dicMerchantDepartmentStatus } from '../../axios/dictionaries';
import { formatTime } from '../../utils/index'

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                merchantId: '0',
                name: '', //岗位名称
                keyword: '', //关键字
                pageSize: 10
            }, //搜索参数
            owner: 1, //商户岗位
            current: 1, //当前页
            tableData: [{ id: 1, name: '测试' }], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            createOrEdit: false, //默认为创建
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            createOrEdit,
            owner
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="g-2-2" type="primary" icon="plus" onClick={this.newAddRole.bind(this)}>新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                        showCancel={false}
                    />
                </div>

                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleDelete: this.handleDelete })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <RoleAdd
                    onRef={ref => this.roleAddRef = ref}
                    visible={showAddModal}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    owner={owner}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch()
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true })
        this.roleAddRef.loadPack({ id })
        //  this.roleAddRef.initPack();
    }

    newAddRole() { //新增
        this.setState({ showAddModal: true, createOrEdit: false });
        // this.roleAddRef.initPack();
    }

    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { roleId: id, owner: this.state.owner };
        postFrom({
            url: config.API_role_delRole,
            data,
        }).then(res => {
            this.setState({ loading: false });
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || "删除失败");
            this.setState({ loading: false });
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current, owner } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign(params, values, { owner });
        } else {
            data = Object.assign({}, params, values, { current, owner });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_role_findPage,
            data,
        }).then(res => {
            let records = res.records;
            records.map(item => item.updateTime = formatTime(item.updateTime))
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }
}

const searchData = () => [
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在岗位名称内模糊查询'
    },
];
const columns = ({ current, handleEdit, handleDelete }) => [

    {
        title: '岗位',
        dataIndex: 'name'
    },
    {
        title: '说明',
        dataIndex: 'remark'
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicMerchantDepartmentStatus.find(item => item.value == text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (
                <div>
                    <AuthButton authkey="g-2-3">
                        <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                    </AuthButton>
                    {
                        !record.isAdmin ?
                        <span>
                            <Divider type="vertical" />
                            <AuthButton authkey="g-2-4">
                                <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                                    <span className="showClickDetail">删除</span>
                                </Popconfirm>
                            </AuthButton>
                        </span> :
                        null
                    }
                </div>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/Employee/Role.js